import { render, staticRenderFns } from "./merchant-list.vue?vue&type=template&id=242bdf35&scoped=true&"
import script from "./merchant-list.vue?vue&type=script&lang=ts&"
export * from "./merchant-list.vue?vue&type=script&lang=ts&"
import style0 from "./merchant-list.vue?vue&type=style&index=0&id=242bdf35&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242bdf35",
  null
  
)

export default component.exports